<template>
    <div class="vip" :class="{'vipDark': isDark}">
        <van-sticky>
            <div class="top" :style="{height: '88px'}">
                <div class="back" @click="gotoBack"><van-icon name="arrow-left" /></div>
                <div class="barTitle">会员中心</div>
            </div>
        </van-sticky>
        <div class="content">
            <div v-if="user_info == null" class="userInfo">
                <div class="avatar">
                    <img src="../../assets/img/common/default1.png" alt="">
                </div>
                <div class="info">
                    <p class="name">登录</p>
                </div>
            </div>
            <div v-else class="userInfo">
                <div class="avatar">
                    <img :src="user_info.avatar" alt="">
                    <img v-if="user_info.mp_rank === '1'" class="author" src="../../assets/img/talent/authorlevel1.png" alt="" />
                    <img v-else-if="user_info.mp_rank === '2'" class="author" src="../../assets/img/talent/authorlevel2.png" alt="" />
                    <img v-else-if="user_info.mp_rank === '3'" class="author" src="../../assets/img/talent/authorlevel3.png" alt="" />
                </div>
                <div class="info">
                    <p v-if="user_info.nickname" class="name">{{user_info.nickname}}</p>
                    <p v-else class="name">登录</p>
                    <p class="notice">
                        <!-- 未开通会员 -->
                        <template v-if="member_info.big_active != 1 && member_info.small_active != 1">
                            <span v-if="member_info.can_experience == 1">新用户可免费体验3天小会员</span>
                            <span v-else>当前未开通会员，赶快去开通吧~</span>
                        </template>
                        <!-- 已开通会员 -->
                        <template v-else>
                            <span v-if="member_info.big_active == 1">{{member_info.big_text}}</span>
                            <span v-if="member_info.small_active == 1">{{member_info.small_text}}</span>
                        </template>
                    </p>
                </div>
            </div>
            <div class="tabBox">
                <div class="tabs">
                    <span @click="changeTab(32)" :class="{'tabsActive': vip_type==32}">小会员</span>
                    <span @click="changeTab(31)" :class="{'tabsActive': vip_type==31}">大会员</span>
                </div>
            </div>
            <div class="priceVisual">
                <div class="priceContainer">
                    <div class="priceBox" :style="{width: price_list.length > 4 ? (price_list.length * 25 - 3 + '%') : '100%'}">
                        <div
                            v-for="(item, index) in price_list" :key="'price'+index"
                            @click="changeChooice(index, item)"
                            class="item" :class="{'itemActive': price_type == index}"
                        >
                            <p class="time">{{item.number}}{{item.type_name}}</p>
                            <p class="price">{{item.money/100}}<span>元</span></p>
                            <p class="originPrice">  {{item.old_money/100}}元  </p>
                            <p class="value">平均{{(item.money/(100 * 30 * item.number)).toFixed(1)}}元/天</p>
                            <p v-if="item.experience" class="tips">新用户专享</p>
                            <p v-else-if="dealOffset(item.old_money, item.money) > 0" class="tips">立省{{dealOffset(item.old_money, item.money)}}嗨币</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="rights">
                <div class="rightsBox">
                    <div class="header">
                        <div class="tips leftTips"></div>
                        <p>会员权益</p>
                        <div class="tips rightTips"></div>
                        <img src="../../assets/img/other/diamond.png" alt="">
                    </div>
                    <div class="list">
                        <div v-for="(item, index) in rightList.list" :key="'right'+index" class="item">
                            <div class="img">
                                <img :src="item.img" alt="">
                            </div>
                            <div class="info">
                                <h2>{{item.title}}</h2>
                                <p>{{item.desc}}</p>
                            </div>
                            <div class="btn" @click="goto(item.jump_info)">{{item.button}}<div class="del">{{item.price}}</div></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="agreement">
                <h2>购买会员即表示同意以下协议</h2>
                <div class="agree">
                    <div class="item" @click="goAgreement('user')">
                        <p>《即嗨用户服务条款》</p>
                        <span><van-icon name="arrow" /></span>
                    </div>
                    <div class="item" @click="goAgreement('day')">
                        <p>《连续订阅服务协议》</p>
                        <span><van-icon name="arrow" /></span>
                    </div>
                </div>
                <div class="infoma">会员由即嗨体育提供，与苹果公司Apple.lnc无关</div>
            </div>
            <div class="placeholder"></div>
            <div class="footerBox">
                <div class="footer">
                    <!-- ios -->
                    <div class="info" v-if="isIOS()">
                        <p class="price" v-if="price_list.length > 0">￥{{price_list[price_type].money/100}}</p>
                        <p class="other" v-if="price_list.length > 0">
                            <span>价格 {{price_list[price_type].money/100}}</span>
                        </p>
                    </div>
                    <!-- 安卓 -->
                    <div class="info" v-else>
                        <p class="price">￥{{checkPayMoney}}</p>
                        <p class="other" v-if="price_list.length > 0">
                            <span v-if="price_list.length > 0">价格 {{price_list[price_type].money/100}}</span>
                            <span v-if="price_list.length > 0">余额 -￥{{(wallet_info.balance >= price_list[price_type].money) ? (price_list[price_type].money/100) : (wallet_info.balance/100)}}</span>
                            <!-- <span class="red">红包-￥10></span> -->
                        </p>
                    </div>
                    <div @click="pay" class="payBtn">
                        <p>立即开通</p>
                        <span v-show="vip_type==31">每月可省{{bigCheap}}元</span>
                        <span v-show="vip_type==32">每月可省{{smallCheap}}元</span>
                    </div>
                </div>
                <div class="footerApp" :style="{height: bottomHeight + 'px'}"></div>
            </div>
        </div>
        <van-popup
            v-model="showPayModel"
            round position="bottom" :style="{ height: '380px' }"
        >
            <div class="payModel">
                <div class="title">
                    <p>请选择支付方式</p>
                    <strong>￥{{checkPayMoney}}</strong>
                    <div class="close" @click="showPayModel = false"><van-icon name="cross" /></div>
                </div>
                <div class="payBox">
                    <div class="item" v-for="(item, index) in payList" :key="index" @click="selectPayWay(item)">
                        <div class="info">
                            <div class="logo">
                                <img v-if="item.type == 'alipay'" src="../../assets/img/common/icon_pay_zfb.png" alt="">
                                <img v-if="item.type == 'wechat_pay'" src="../../assets/img/common/icon_pay_wechat.png" alt="">
                            </div>
                            <p>{{item.name}}</p>
                            <span class="desc" v-if="item.sub_name">{{item.sub_name}}</span>
                        </div>
                        <div class="checkbox">
                            <img v-show="tabs.pay_type != item.pay_type" src="../../assets/img/common/icon_pay_default.png" alt="">
                            <img v-show="tabs.pay_type == item.pay_type" src="../../assets/img/common/icon_pay_selected.png" alt="">
                        </div>
                    </div>
                    <!-- <div class="item" @click="selectPayWay('yb')">
                        <div class="info">
                            <div class="logo"><img src="../../assets/img/common/icon_pay_bank.png" alt=""></div>
                            <p>银联支付</p>
                            <span class="desc">（推荐使用银联支付～）</span>
                        </div>
                        <div class="checkbox">
                            <img v-show="payChannel != 'yb'" src="../../assets/img/common/icon_pay_default.png" alt="">
                            <img v-show="payChannel == 'yb'" src="../../assets/img/common/icon_pay_selected.png" alt="">
                        </div>
                    </div>
                    <div class="item" :class="checkPayMoney >= 100 ? 'unsupport' : ''" @click="selectPayWay('wx')">
                        <div class="info">
                            <div class="logo"><img src="../../assets/img/common/icon_pay_wechat.png" alt=""></div>
                            <p>微信支付</p>
                            <span class="desc">（支付金额小于100元）</span>
                        </div>
                        <div class="checkbox" v-if="checkPayMoney < 100">
                            <img v-show="payChannel != 'wx'" src="../../assets/img/common/icon_pay_default.png" alt="">
                            <img v-show="payChannel == 'wx'" src="../../assets/img/common/icon_pay_selected.png" alt="">
                        </div>
                    </div>
                    <div class="item" :class="checkPayMoney >= 100 ? 'unsupport' : ''" @click="selectPayWay('ali_xz')">
                        <div class="info">
                            <div class="logo"><img src="../../assets/img/common/icon_pay_zfb.png" alt=""></div>
                            <p>支付宝</p>
                            <span class="tips">NEW</span>
                            <span class="desc">（支付金额小于100元）</span>
                        </div>
                        <div class="checkbox" v-if="checkPayMoney < 100">
                            <img v-show="payChannel != 'ali_xz'" src="../../assets/img/common/icon_pay_default.png" alt="">
                            <img v-show="payChannel == 'ali_xz'" src="../../assets/img/common/icon_pay_selected.png" alt="">
                        </div>
                    </div> -->
                </div>
                <div @click="getPayDataBuy" class="footerBtn">
                    立即开通
                </div>
            </div>
        </van-popup>
        <van-dialog v-model="showNotice" :showConfirmButton="false" width="315px">
            <div class="modelBox">
                <p>是否立即开通</p>
                <div class="btnBox">
                    <span @click="showNotice=false">我再想想</span>
                    <span @click="openNow" class="ok">立即开通</span>
                </div>
            </div>
        </van-dialog>
        <van-dialog v-model="gotoLogin" :showConfirmButton="false" width="315px">
            <div class="modelBox">
                <p>温馨提示</p>
                <div class="btnBox">
                    <span @click="gotoBack">取消</span>
                    <span @click="goLogin" class="ok">去登录</span>
                </div>
            </div>
        </van-dialog>
        <van-popup class="popupPayNoticeModel" round v-model="paymentReminderShow" :close-on-click-overlay="false">
            <div class="payNoticeModel">
                <h2>网上支付提示</h2>
                <p>支付完成前，请不要关闭此支付验证弹窗</p>
                <p>支付完成后，请根据您的支付情况点击下面的按钮</p>
                <div class="btnBox">
                    <span class="cancel" @click="payOk">支付遇到问题</span>
                    <span class="ok" @click="payOk(1)">支付完成</span>
                </div>
            </div>
        </van-popup>
        <div v-html="payHtml"></div>
    </div>
</template>

<script>
import { getVipInfo, getVipRight, vipBuy, balanceBuy, iosPayConfig } from "../../api/vip";
import { getPayRechargeConfig, getPayRechargePay, getPayDataBuy } from "@/api/user"
import { isJHAppios, getAppV, isAppPay, isJHApp, isIOS, doLogin, isJHAppAn, getAppTopHeight, getCookie, getAppBottomHeight, encrypHyAlipay, getQueryVariable } from "../../utils/base";
import { Dialog } from "vant"
import jsbridg from '../../utils/jsbridg';
import pay from "../../utils/pay";
let jhId = "";
export default {
    name: 'vip',
    data () {
        return {
            screen_h: getCookie('screen_h'),
            // src: this.$route.query.src,
            src: getQueryVariable('src'),
            topHeight: 20,
            bottomHeight: 0,
            vip_type: 31, // 31-大会员 32-小会员
            big_info: [], // 大会员基本信息
            small_info: [], // 小会员基本信息
            currentPriceItem: {}, // 当前选中的价格
            user_info: null, // 用户信息
            wallet_info: {}, // 钱包信息
            member_info: {}, // 会员信息
            bigCheap: '', // 大会员立省
            smallCheap: '', // 大会员立省
            price_type: 0,
            a: 1,
            rightList: [], // 权益列表
            showPayModel: false, // 第三方支付弹窗
            showNotice: false, // 支付确认弹窗
            payChannel: 'yb', // 支付渠道 ali-支付宝1 yb-银联 wx-微信 ali_xz支付宝2
            tradeNo: null, // 订单号
            payHtml: '',
            iosPayConfigList: {}, // ios价格配置信息
            gotoLogin: false,
            alertMode: false,

            payList: [],
            tabs: '',
            paymentReminderShow: false,
            sreturnModel: this.$route.query.sreturnModel
        }
    },
    computed: {
        price_list () {
            if (this.vip_type === 31) {
                return this.big_info
            } else {
                return this.small_info
            }
        },
        checkPayMoney () {
            if (this.price_list.length > 0) {
                if (this.wallet_info.balance - this.price_list[this.price_type].money >= 0) {
                    return 0;
                } else {
                    return Math.abs(this.wallet_info.balance - this.price_list[this.price_type].money) / 100;
                }
            } else {
                return 0;
            }
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        if (this.sreturnModel) {
            jsbridg.closeWebview()
        }
        this.initVipInfo();
        document.getElementsByTagName('title')[0].innerHTML = '会员中心';
        this.topHeight = getAppTopHeight();
        this.bottomHeight = getAppBottomHeight();
        this.getPayRechargeConfig()
        if (getQueryVariable('vipType')) {
            this.changeTab(getQueryVariable('vipType') * 1)
            if (getQueryVariable('old') && ((getQueryVariable('old') * 1) === 1)) {
                // this.alertMode = true
                Dialog.confirm({
                    title: '提示',
                    message: '您已经是老用户了，开通大会员每月可帮您节省974元哟~',
                    confirmButtonText: '立即开通',
                    cancelButtonText: '再想想'
                })
                    .then(() => {
                        this.pay()
                    })
                    .catch(() => {
                    // on cancel
                    });
            }
        }
    },
    mounted () {
        // 隐藏客户端bar
        jsbridg.hideAppBar(0);
        const _this = this;
        // app支付完成回调函数
        window.appPaycallback = function (data) {
            if (data === "ok") {
                _this.initVipInfo();
            } else if (data === "error") {
                // 会员开通失败
            }
        };
    },
    methods: {
        isJHAppiosStyle () {
            return isJHAppios()
        },
        payOk () {
            window.location.reload()
        },
        encapsulationUrl () {
            if (window.location.href.indexOf('?') > -1) {
                return window.location.href + '&sreturnModel=1'
            } else {
                return window.location.href + '?sreturnModel=1'
            }
        },
        // 模型购买
        async getPayDataBuy () {
            this.$toast.loading({
                message: '正在支付中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0
            });
            const params = {
                data_type: this.vip_type,
                src: this.src,
                price_id: this.currentPriceItem.id
            }
            // if (this.couponItem) {
            //     params.bonus_id = this.couponItem.id
            // }
            const res = await getPayDataBuy(params)
            if (res.errno * 1 === 0) {
                this.$toast.clear()
                this.$toast.success('支付成功');
                this.initVipInfo()
            } else if (res.errno * 1 === 6102) {
                this.getPayRechargePay(res.data.diff_fee / 100)
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        //  充值并购买
        async getPayRechargePay (price) {
            this.$toast.loading({
                message: '正在支付中...',
                forbidClick: true,
                loadingType: 'spinner',
                duration: 0
            });
            const params = {
                amount: price,
                pay_type: this.tabs.pay_type,
                trade_type: this.tabs.trade_type,
                return_url: this.encapsulationUrl(),
                src: this.src,
                order_type: 'pay_data',
                ext_info: {
                    src: this.src,
                    data_type: this.vip_type,
                    price_id: this.currentPriceItem.id
                }
            }
            // 若是以后有红包可以用
            // if (this.couponItem) {
            //     params.ext_info.bonus_id = this.couponItem.id
            // }
            params.ext_info = JSON.stringify(params.ext_info)
            const res = await getPayRechargePay(params)
            this.$toast.clear()
            if (res.errno * 1 === 0) {
                // 逻辑待添加
                if (this.tabs.type === 'alipay') {
                    this.paymentReminderShow = true
                    // this.trade_no = res.data.trade_no
                    jsbridg.goWebview({
                        url: res.data.target_url,
                        jumptype: 2
                    });
                } else if (this.tabs.type === 'wechat_pay') {
                    jsbridg.appWXPay(res.data)
                }
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        // 获取支付渠道
        async getPayRechargeConfig () {
            const params = {
                scene: 'app'
            }
            const res = await getPayRechargeConfig(params)
            if (res.errno * 1 === 0) {
                this.payList = res.data.list
                this.tabs = res.data.list[0]
            } else {
                this.$toast.fail(res.errmsg);
            }
        },
        goAgreement (type) {
            let url = "";
            if (type === 'user') {
                url = process.env.VUE_APP_DOMAIN + '/agreement/userAgreement'
            } else {
                url = process.env.VUE_APP_DOMAIN + '/agreement/monthlyAgreement'
            }
            if (url) {
                // if (isAppPay()) {
                jsbridg.goWebview({
                    url: url,
                    jumptype: 2
                });
                // } else {
                //     window.open(url, "_blank");
                // }
            }
        },
        // 处理基本会员信息
        async initVipInfo () {
            const res = await getVipInfo({
                src: this.src
            })
            if (res.errno === 0) {
                this.big_info = res.data.big_info;
                this.bigCheap = res.data.big_cheap;
                this.small_info = res.data.small_info;
                this.smallCheap = res.data.small_cheap;
                this.member_info = res.data.member_info;
                this.wallet_info = res.data.wallet_info;
                if (this.vip_type * 1 === 31) {
                    this.currentPriceItem = this.big_info[0];
                } else {
                    this.currentPriceItem = this.small_info[0];
                }
                if (res.data.user_info) {
                    this.user_info = res.data.user_info;
                } else {
                    // 未登录
                    doLogin();
                    this.gotoLogin = true;
                }
            } else if (res.errno === -1) {
                // doLogin();
            } else {
                this.$toast(res.errmsg)
            }
            this.initVipRightList();
        },
        // 跳转到登录
        goLogin () {
            doLogin();
        },
        // 处理优惠金额
        dealOffset (num1, num2) {
            return (num1 - num2) / 100
        },
        // 初始化权益列表
        async initVipRightList () {
            const res = await getVipRight({
                src: this.src,
                data_type: this.vip_type,
                experience: this.currentPriceItem.experience
            })
            if (res.errno === 0) {
                this.rightList = res.data
            } else {
                this.$toast(res.errmsg)
            }
        },
        // 切换tab
        changeTab (type) {
            this.vip_type = type;
            this.price_type = 0;
            if (type === 31) {
                this.currentPriceItem = this.big_info[0];
            } else {
                this.currentPriceItem = this.small_info[0];
            }
            this.initVipRightList();
        },
        // 切换套餐
        changeChooice (index, item) {
            this.price_type = index;
            this.currentPriceItem = item;
            this.initVipRightList();
        },
        // 选择支付方式
        selectPayWay (type) {
            // if ((type === 'wx' || type === 'ali_xz') && this.checkPayMoney >= 100) {
            //     return;
            // }
            // this.payChannel = type;
            this.tabs = type
        },
        // 支付
        async pay () {
            // 免费3天体验
            if (this.currentPriceItem.experience === 1) {
                this.showNotice = true;
            } else {
                // ios
                if (isJHAppios()) {
                    // ios产品配置信息
                    const res = await iosPayConfig()
                    if (res.errno === 0) {
                        this.iosPayConfigList = res.data.not_auto || {};
                        // 当前productId
                        let _productId = '';
                        if (this.price_list[this.price_type].experience !== 1) {
                            _productId = this.iosPayConfigList[this.vip_type][this.price_type].key;
                        } else {
                            _productId = '';
                        }
                        const parms = {
                            type: this.vip_type,
                            fee: this.price_list[this.price_type].id,
                            is_auto: 0,
                            productId: _productId
                        };
                        jsbridg.iosBigDataPay(parms);
                    }
                } else {
                    // 安卓
                    if (this.checkPayMoney > 0) {
                        // 唤起底部第三方支付弹窗
                        this.buyUseBalance('sf');
                        // 默认支付方式特殊处理
                        if ((this.payChannel === 'wx' || this.payChannel === 'ali_xz') && this.checkPayMoney >= 100) {
                            this.payChannel = 'ali';
                        }
                        this.showPayModel = true;
                    } else {
                        // 余额充足
                        this.showNotice = true;
                    }
                }
            }
        },
        // 立即开通
        openNow () {
            if (this.currentPriceItem.experience === 1) {
                this.freeUse();
            } else {
                this.buyUseBalance();
            }
        },
        // 免费体验
        async freeUse () {
            const res = await vipBuy({
                src: this.src,
                data_type: this.vip_type,
                experience: this.currentPriceItem.experience
            })
            if (res.errno === 0) {
                this.$toast('恭喜您已开通');
                this.showNotice = false;
                this.initVipInfo();
            } else {
                this.$toast(res.errmsg);
            }
        },
        // 安卓支付-生成订单号
        async buyUseBalance (type) {
            const res = await balanceBuy({
                is_auto: 0,
                type: this.vip_type,
                fee: this.price_list[this.price_type].id,
                month: this.price_list[this.price_type].number,
                src: this.src,
                _t: new Date().getTime()
            })
            // 余额充足
            if (res.errno === 0) {
                this.$toast('恭喜您已开通');
                this.showNotice = false;
                this.initVipInfo();
            } else if (res.errno === 2202) {
                // 余额不足
                this.tradeNo = res.data.trade_no;
                if (type === 'sf') {
                    this.showPayModel = true;
                } else {
                    this.showPayModel = false;
                }
            } else {
                this.$toast(res.errmsg)
            }
        },
        // 第三方支付
        finalPay () {
            const _this = this;
            this.showNotice = false; // 关闭确认弹窗
            const param = {};
            param.total_fee = this.checkPayMoney;
            // 支付账户类型
            param.pay_type = this.payChannel;
            param.ordertype = 'pay_data'; // 订单类型
            param.trade_no = this.tradeNo; // 订单号
            param.appv = getAppV(); // 版本号
            this.showPayModel = false; // 关闭支付弹框
            pay.payinit(param, function (info, typeName) {
                // bfbpay: 贝付宝
                // hy_ali：红月
                // qq： QQ钱包支付扫码支付
                // qqApp: QQ钱包支付 SDK
                // yse_pay: 网银支付
                if (typeName && (typeName === "bfbpay" || typeName === "hy_ali" || typeName === "qq" || typeName === "yse_pay" || typeName === "qqApp")) {
                    // 获取订到号
                    _this.getTradeNo(info);
                    // qq钱包
                    if (typeName === "qq") {
                        this.goQQPay(info.code_url);
                    }
                    // 网银支付
                    if (typeName === "yse_pay" && info.data) {
                        this.goCardPay(info);
                    }
                } else if (typeof info === "object") {
                    // 获取订到号
                    _this.getTradeNo(info.data);
                    // 贝付宝
                    if (info.data && info.data._pay_type === 'bfb_ali') {
                        window.location.href = encrypHyAlipay(info.data.pay_url);
                    } else if (info._pay_type === "wx") {
                        // 微信
                        var payUrl = info.data.pay_url;
                        if (!isJHApp() && isIOS()) {
                            window.location.href = payUrl;
                        } else {
                            this.payHtml = `<form target="_blank" method="post" action=${payUrl} name="wx_pay"></form>`;
                            document.forms.wx_pay.submit();
                        }
                    } else if (info._pay_type === "ali_xz") {
                        // 西藏嗨娱
                        const div = document.createElement('div');
                        const originStr = info.data;
                        const str = originStr.replace("document.forms['alipaysubmit'].submit()", '');
                        div.innerHTML = str;
                        document.body.appendChild(div);
                        document.getElementById('alipaysubmit').submit();
                    } else if (info._pay_type === "yop_pay") {
                        // 易宝支付
                        window.location.href = info.data.url;
                    } else {
                        // 支付宝 、银联 都是FORM表单形式返回
                        this.payHtml = info.data.replace("<form", "<form target='_this'");
                    }
                } else if (info === "ok" || info === "error") {
                    this.$toast(info);
                }
            })
        },
        // 获取交易号 供查询使用
        getTradeNo (info) {
            if (!jhId) {
                if (typeof info === "object") {
                    if (info.trade_no) {
                        jhId = info.trade_no;
                    } else if (info.data && info.data.serialNumber) {
                        jhId = info.data.serialNumber;
                    };
                } else if (info.indexOf('jhId=') >= 0) {
                    const outTradeNo = info.match(/(jhId=)(\d{1,})/);
                    jhId = outTradeNo[2];
                }
            }
        },
        // 去外部浏览器，打开QQ支付
        goQQPay (codeUrl) {
            if (codeUrl) {
                const origin = window.location.origin || window.location.protocol + "//" + window.location.hostname || "https://h6.jihai8.com";
                const url = origin + "/page/qq_pay?code_url=" + encodeURIComponent(codeUrl);
                jsbridg.goWebview({
                    url: url,
                    jumptype: 3
                });
            } else {
                // console.warn("没有支付地址！！！")
            }
        },
        // 去网银支付
        goCardPay (info) {
            if (info) {
                let url = "";
                url = "https://h5.jihai8.cn/page/yse_pay?trade_no=" + info.trade_no;
                if (url) {
                    if (isAppPay()) {
                        jsbridg.goWebview({
                            url: url,
                            jumptype: 3
                        });
                    } else {
                        window.open(url, "_blank");
                    }
                }
            }
        },
        // 跳转至对应的地方
        goto (obj) {
            let json = null;
            if (obj.jumptype === 3) {
                // 浏览器
                json = {
                    url: obj.url,
                    jumptype: 3
                }
            } else if (obj.jumptype === 2) {
                // 客户端webview
                json = {
                    url: obj.url,
                    jumptype: 2
                }
            } else if (obj.jumptype === 1) {
                // 客户端原生
                let jumpParams = "";
                if (obj.params) {
                    if (obj.params.indexOf("#sign_in=0") > -1) {
                        jumpParams = obj.params.replace("#sign_in=0", "");
                    } else if (obj.params.indexOf("&sign_in=0") > -1) {
                        jumpParams = obj.params.replace("&sign_in=0", "");
                    } else if (obj.params.indexOf("sign_in=0") > -1) {
                        jumpParams = obj.params.replace("sign_in=0", "");
                    } else {
                        jumpParams = obj.params;
                    }
                }
                json = {
                    code: obj.code,
                    params: jumpParams,
                    jumptype: 1
                }
            }
            jsbridg.goWebview(json);
        },
        isIOS () {
            return isJHAppios();
        },
        // 返回上级
        gotoBack (status) {
            // this.gotoLogin = false
            // android 1关闭 2返回
            if (isJHAppAn()) {
                if (status === 1) {
                    jsbridg.closeWebview();
                } else {
                    jsbridg.goBack();
                }
            } else {
                jsbridg.goBack();
            }
        }
    }
}
</script>

<style lang="less" scoped>
@keyframes getBigger {
    0%{
        transform: scale(1);
    }
    15%{
        transform: scale(1.02);
    }
    25%{
        transform: scale(1.03);
    }
    50%{
        transform: scale(1.05);
    }
    65%{
        transform: scale(1.03);
    }
    75%{
        transform: scale(1.02);
    }
    100%{
        transform: scale(1);
    }
}
.vip{

    width: 100%;
    .top{
        width: 100%;
        // height: 88px;
        background: linear-gradient(180deg, #40488D 0%, #272C57 100%);
        position: relative;
        .back{
            width: 45px;
            height: 45px;
            line-height: 45px;
            color: #fff;
            text-align: center;
            font-size: 20px;
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 20;
        }
        .barTitle{
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 45px;
            line-height: 45px;
            color: #fff;
            text-align: center;
            font-size: 20px;
            z-index: 10;
        }
    }
    .content{
        background-color: #272C57;
        padding-top: 25px;
        .userInfo{
            width: 100%;
            padding: 0 14px;
            overflow: hidden;
            .avatar{
                position: relative;
                width: 50px;
                height: 50px;
                overflow: hidden;
                float: left;
                img{
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    object-fit: cover;
                    &.author{
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 15px;
                        height: 15px;
                        border-radius: 0%;
                    }
                }
            }
            .info{
                color: #fff;
                float: left;
                margin-left: 10px;
                .name{
                    font-size: 16px;
                    line-height: 22px
                }
                .notice{
                    font-size: 11px;
                    line-height: 15px;
                    margin-top: 4px;
                    span{
                        display: block;
                    }
                }
            }
        }
        .tabBox{
            width: 100%;
            padding: 0 14px;
            margin-top: 22px;
            .tabs{
                width: 100%;
                // height: 32px;
                background-color: #eee;
                border-radius: 4px;
                text-align: center;
                overflow: hidden;
                span{
                    display: inline-block;
                    font-size: 15px;
                    color: #7D7D7D;
                    width: 50%;
                    padding: 6px 0;
                    font-weight: bold;
                }
                span.tabsActive{
                    color: #fff;
                    background-color: #169AFF;
                }
            }
        }
        .priceVisual{
            width: 100%;
            padding: 0 14px;
            .priceContainer{
                width: 100%;
                overflow-x: scroll;
                .priceBox{
                    width: 100%;
                    margin-top: 20px;
                    display: flex;
                    justify-content: space-between;
                    .item{
                        width: 83px;
                        height: 106px;
                        background: #FFFFFF;
                        border-radius: 4px;
                        border: 1px solid #fff;
                        position: relative;
                        text-align: center;
                        .time{
                            font-size: 13px;
                            color: #333;
                            margin-top: 13px;
                            line-height: 18px;
                        }
                        .price{
                            font-size: 23px;
                            color: #FF5048;
                            font-weight: bold;
                            line-height: 28px;
                            font-family: DINAlternate-Bold, DINAlternate;
                            span{
                                font-size: 12px;
                            }
                        }
                        .originPrice{
                            font-size: 12px;
                            line-height: 15px;
                            color: #B4B4B4;
                            text-decoration: line-through;
                        }
                        .value{
                            font-size: 10px;
                            color: #169AFF;
                            margin-top: 5px;
                            line-height: 14px;
                        }
                        .tips{
                            width: 70px;
                            height: 16px;
                            background: #FF5048;
                            border-radius: 0px 6px 0px 6px;
                            line-height: 16px;
                            position: absolute;
                            top: -8px;
                            left: calc(50% - 35px);
                            font-size: 10px;
                            color: #fff;
                        }
                    }
                    .itemActive{
                        border-color: #169AFF;
                        background-color: #EAF4FE;
                    }
                }
            }
        }
        .rights{
            width: 100%;
            padding: 0 14px 1px 14px;
            margin-top: 16px;
            .rightsBox{
                padding: 10px;
                background-color: rgba(255,255,266,.06);
                border-radius: 5px;
            }
            .header{
                margin: 11px auto;
                width: calc(100% - 50px);
                display: flex;
                justify-content: space-between;
                position: relative;
                .tips{
                    width: 78px;
                    height: 1px;
                    margin-top: 13px;
                }
                .leftTips{
                    background: linear-gradient(90deg, rgba(255, 248, 233, 0) 0%, #FFE2A1 100%);
                }
                .rightTips{
                    background: linear-gradient(270deg, rgba(255, 248, 233, 0) 0%, #FFE2A1 100%);
                }
                p{
                    font-size: 20px;
                    font-weight: bolder;
                    color: #333333;
                    line-height: 28px;
                    padding-left: 15px;
                    text-shadow: 0px 1px 1px rgba(22, 26, 51, 0.15);
                    background: linear-gradient(180deg, #FFF8E9 0%, #FFE2A1 100%);
                    -webkit-text-fill-color: transparent;
                    -webkit-background-clip:text;
                    position: relative;
                    z-index: 1;
                }
                img{
                    position: absolute;
                    width: 28px;
                    left: calc(50% - 50px);
                }
            }
            .item{
                width: 100%;
                height: 75px;
                background: linear-gradient(180deg, #FFF6E3 0%, #FFE6AE 100%);
                box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.1);
                border-radius: 4px;
                margin-bottom: 16px;
                padding: 10px;
                display: flex;
                justify-content: space-between;
                .img{
                    width: 45px;
                    height: 45px;
                    margin-left: 5px;
                    border-radius: 50%;
                    overflow: hidden;
                    background-color: aqua;
                    margin-top: 5px;
                }
                .info{
                    width: calc(100% - 135px);
                    h2{
                        font-size: 15px;
                        font-weight: bold;
                        color: #443315;
                        line-height: 21px;
                    }
                    p{
                        margin-top: 4px;
                        font-size: 11px;
                        font-weight: 400;
                        color: #443315;
                        line-height: 15px;
                    }
                }
                .btn{
                    position: relative;
                    text-align: center;
                    width: 65px;
                    height: 28px;
                    line-height: 28px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    font-size: 13px;
                    color: #796138;
                    margin-top: 13px;
                    .del{
                        position: absolute;
                        left: 0;
                        bottom: -24px;
                        width: 65px;
                        color: #FF5048;
                        font-weight: bold;
                        text-decoration: line-through;
                    }
                }
            }
        }
        .agreement{
            padding: 16px 16px 0 16px;
            text-align: left;
            color: #fff;
            h2{
                font-size: 14px;
                font-weight: bold;
                line-height: 20px;
            }
            .agree{
                .item{
                    display: flex;
                    justify-content: space-between;
                    height: 44px;
                    line-height: 44px;
                    border-bottom: 1px solid rgba(255,255,266,.06);
                    p{
                        font-size: 15px;
                        font-weight: bold;
                        color: #FFE6AE
                    }
                }
            }
            .infoma{
                font-size: 12px;
                line-height: 16px;
                margin-top: 10px;
            }
        }
        .placeholder{
            width: 100%;
            height: 110px;
        }
        .footerBox {
            width: 100%;
            height: auto;
            position: fixed;
            bottom: 0;
            left: 0;
            .footer{
                width: 100%;
                // height: 95px;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                padding: 6px 15px;
                box-sizing: border-box;
                .info{
                    .price{
                        font-size: 27px;
                        font-weight: bold;
                        color: #FF5048;
                        line-height: 31px;
                        span{
                            font-size: 10px;
                        }
                    }
                    .other{
                        line-height: 15px;
                        span{
                            font-size: 10px;
                            color: #333;
                            margin-right: 10px;
                        }
                        .red{
                            color: #FF5048;
                            font-size: 11px;
                            font-weight: bold;
                        }
                    }
                }
                .payBtn{
                    animation: getBigger .8s infinite;
                    width: 110px;
                    height: 44px;
                    background: #169AFF;
                    border-radius: 5px;
                    color: #fff;
                    text-align: center;
                    p{
                        font-size: 15px;
                        line-height: 21px;
                        margin-top: 5px;
                    }
                    span{
                        font-size: 10px;
                        line-height: 14px;
                    }
                }
            }
            .footerApp{
                width: 100%;
                background-color: #ffffff;
            }
        }
    }
    .payModel{
        text-align: center;
        padding: 10px 14px;
        .title{
            position: relative;
            p{
                font-size: 15px;
                font-weight: 400;
                color: #333333;
                line-height: 21px;
            }
            strong{
                font-size: 30px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                color: #333333;
                line-height: 35px;
                margin-top: 5px;
            }
            .close{
                width: 40px;
                height: 30px;
                line-height: 30px;
                position: absolute;
                right: 0;
                top: 0;
                font-size: 18px;
                color: #565353;
            }
        }
        .payBox{
            border-top: 1px solid #eee;
            margin-top: 15px;
            .item{
                width: 100%;
                height: 45px;
                line-height: 45px;
                border-bottom: 1px solid #eee;
                display: flex;
                justify-content: space-between;
                &.unsupport{
                    -webkit-filter: grayscale(1);
                    -moz-filter: grayscale(1);
                    -ms-filter: grayscale(1);
                    -o-filter: grayscale(1);
                    filter: grayscale(1);
                    filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1); //css滤镜代码
                }
                .info{
                    overflow: hidden;
                    .logo{
                        width: 25px;
                        height: 25px;
                        float: left;
                        margin-top: 10px;
                    }
                    p{
                        float: left;
                        margin-left: 5px;
                        font-size: 13px;
                        color: #333;
                    }
                    .tips{
                        display: block;
                        width: auto;
                        height: 11px;
                        padding: 1px 5px 0;
                        background-color: #FF5048;
                        float: left;
                        border-radius: 6px;
                        border-bottom-left-radius: 0;
                        margin-top: 17px;
                        line-height: 11px;
                        font-size: 10px;
                        color: #fff;
                        margin-left: 5px;
                    }
                    .desc{
                        font-size: 12px;
                        color: #666;
                    }
                }
                .checkbox{
                    width: 20px;
                    height: 20px;
                    margin-top: 6px;
                    img{
                        width: 100%;
                    }
                }
            }
        }
        .footerBtn{
            width: 100%;
            height: 44px;
            line-height: 44px;
            background: #169AFF;
            border-radius: 5px;
            font-size: 15px;
            color: #fff;
            margin-top: 8px;
        }
    }
    .modelBox{
        width: 100%;
        height: 141px;
        border-radius: 4px;
        background-color: #ffffff;
        padding: 0 16px;
        position: relative;
        display: table;
        p{
            font-size: 14px;
            color: #222;
            line-height: 21px;
            margin-top: 33px;
            text-align: center;
        }
        .btnBox{
            position: absolute;
            width: 100%;
            height: 53px;
            border-top: 0.2px solid #e8e8e8;
            left: 0;
            bottom: 0;
            span{
                display: inline-block;
                margin-top: 18px;
                width: 50%;
                line-height: 17px;
                font-size: 17px;
                text-align: left;
                text-align: center;
            }
            .cancel{
                color: #999999;
                border-right: 1px solid #f5f5f5;
            }
            .ok{
                color: #495CFF;
            }
        }
    }
    /deep/.popupPayNoticeModel{
        width: 300px;
        .payNoticeModel{
            background: #fff;
            border-radius: 30px;
            padding-top: 10px;
            h2{
                text-align: center;
                font-size: 14px;
                line-height: 20px;
                color: #333333;
                margin-bottom: 15px;
                font-weight: bold;
            }
            p{
                padding: 0 16px;
                font-size: 12px;
                color: #666;
                line-height: 18px;
                text-align: left;
            }
            .btnBox{
                width: 100%;
                height: 40px;
                font-size: 13px;
                margin-top: 16px;
                border-top: 1px solid #eee;
                padding-top: 10px;
                span{
                    display: inline-block;
                    width: 50%;
                    color: #939393;
                    border-right: 1px solid #eee;
                    text-align: center;
                }
                .ok{
                    color: #495CFF;
                    border-right: 0;
                }
            }
        }
    }
}
.vipDark{
    /deep/.popupPayNoticeModel{
        background: #191919;
        .payNoticeModel{
            background: #191919;
            h2{
                color: #d3d3d3;
            }
            p{
                color: #a6a6a6;
            }
            .btnBox{
                border-color: #232323;
                span{
                    color: #a6a6a6;
                    border-color: #232323;
                }
            }
        }
    }
    .top{
        background: linear-gradient(180deg, #232323 0%, #191919 100%);
    }
    .content{
        background-color: #191919;
        .tabBox{
            .tabs{
                background-color: #232323;
                span{
                    color: #a6a6a6;
                }
            }
        }
        .priceVisual{
            .priceContainer{
                .priceBox{
                    .item{
                        background-color: #232323;
                        border-color: #232323;
                        .time{
                            color: #d3d3d3;
                        }
                        .originPrice{
                            color: #595959;
                        }
                    }
                    .itemActive{
                        border-color: #169AFF;
                        background: rgba(22,154,255,0.2);
                    }
                }
            }
        }
        .footerBox{
            .footer{
                background-color: #191919;
                border-top: 1px solid #2f2f2f;
                .info{
                    .other{
                        span{
                            color: #d3d3d3;
                        }
                    }
                }
            }
            .footerApp{
                background-color: #191919;
            }
        }
    }
    /deep/.van-dialog, /deep/.van-popup{
        background-color: #191919;
    }
    .payModel{
        background-color: #191919;
        .title{
            p{
                color: #d3d3d3
            }
            strong{
                color: #d3d3d3;
            }
        }
        .payBox{
            border-color: #2f2f2f;
            .item{
                border-color: #2f2f2f;
                .info{
                    p{
                        color: #d3d3d3
                    }
                    .desc{
                        color: #a6a6a6;
                    }
                }
            }
        }
    }
    .modelBox{
        background-color: #191919;
        p{
            color: #d3d3d3;
        }
        .btnBox{
            border-color: #232323;
            color: #595959;
            .cancel{
                color: #595959;
                border-color: #232323;
            }
        }
    }
}
</style>
